/**
 * AuthedRedirect — route-level wrapper. If the user is logged IN,
 * redirect them to whichever dashboard their default workspace lands
 * on. Otherwise render the wrapped children (Landing, Login, Signup).
 *
 * Phase 1 of the App Shell Redesign retires the F1.a "render the auth
 * affordance inside Landing" workaround: logged-in users should never
 * see the public marketing surface in the first place. Same logic
 * applies to /login and /signup — there's no use case for the auth
 * forms once a session exists.
 *
 * Loading window (user === undefined) — render NOTHING (a brief blank
 * frame). Rendering Landing/Login during the loading flash would cause
 * a layout shake when the redirect fires moments later.
 */
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth, pickPostLoginPath } from "@/context/AuthContext";

export default function AuthedRedirect({ children }) {
  const { user } = useAuth();
  if (user === undefined) return null;
  if (user) {
    return <Navigate to={pickPostLoginPath(user) || "/"} replace />;
  }
  return children;
}
